type FSA = { type: string; payload?: any; meta?: any };

const defaultActionCreator = (payload?: any, meta?: any) => ({
  payload,
  ...(meta && { meta }),
});

export const createRequestActionTypes = (name: string) => ({
  REQUEST: `${name}_REQUEST`,
  SUCCESS: `${name}_SUCCESS`,
  FAILED: `${name}_FAILED`,
});
